var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-header",style:({
    backgroundColor: _vm.currentBackgroundColor,
    color: _vm.currentTextColor
})},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"2"}},[(_vm.backLink)?_c('b-link',{staticClass:"text-white",attrs:{"to":_vm.backLink}},[_c('b-icon-chevron-left')],1):_vm._e()],1),_c('b-col',{staticClass:"text-center",attrs:{"cols":"8"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }